import { Box, styled, Tab, Tabs } from '@mui/material';
import { SyntheticEvent, useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import clsx from 'clsx';
import { useResize } from '../../hooks/resize';

interface Props {}

export const Schools: React.FC<Props> = () => {
  const { isMobile } = useResize();
  const navigate = useNavigate();
  const location = useLocation();
  const [schoolData, setSchoolData] = useState<any>(location.state);
  const [value, setValue] = useState<number>(1);
  const tabChange = (event: SyntheticEvent, newValue: number) => {
    const seq = schoolData ? schoolData.schoolClassSeq : '';

    setValue(1);
    navigate('schoolinquire', {
      replace: true,
      state: {
        seq: seq,
      },
    });
  };
  useEffect(() => {
    if (location.state) {
      setSchoolData(location.state);
    }
    const path = window.location.pathname;
    setValue(1);
  }, [window.location.pathname]);

  return (
    <div className={clsx({ root: !isMobile() }, { root_resize: isMobile() })}>
      <Helmet>
        <title>학교 관리</title>
      </Helmet>
      <Outlet />
    </div>
  );
};
